import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { postApi, ApiResponse } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { IRequestEmitirBaixaVeiculo, Types } from './types';

// ACTIONS
import {
	emitirBaixaVeiculoSuccess,
	emitirBaixaVeiculoFailure,
} from './actions';

function* emitirBaixaVeiculoRequest(request: ReducerAction) {
	const { payload }: { payload: IRequestEmitirBaixaVeiculo } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`servicos/${CHANNEL}/emissao/baixas-veiculos`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(emitirBaixaVeiculoSuccess(response));
	} else if (response.error) {
		yield put(emitirBaixaVeiculoFailure());
	}
}

export default all([
	takeLatest(Types.EMITIR_BAIXA_VEICULO_REQUEST, emitirBaixaVeiculoRequest),
]);
